import { RouterView } from "vue-router";
import {OvertimeRouting} from './overtime-application/overtime-application.routing'
import {leaveRouting} from './leave-application/leave-application.routing'
import {travelRouting} from './travel-application/travel-application.routing'
import {gooutRouting} from './goout-application/goout-application.routing'
import {attendanceGroupRouting} from './attendance-group-management/attendance-group-application.routing'
import {attendanceRecordRouting} from './attendance-record/attendance-record.routing'
import {attendanceStatisticsRouting} from './attendance-statistics/attendance-statistics.routing'

export const AttendanceRouting = {
	path: "/attendance",
	name: "attendance",
	redirect: "/attendance/overtime/list",
	component: RouterView,
	meta: { title: "考勤管理", icon: "kaoqin" },
	children: [
	  ...OvertimeRouting,
		...leaveRouting,
		...travelRouting,
		...gooutRouting,
		...attendanceGroupRouting,
		...attendanceRecordRouting,
		...attendanceStatisticsRouting
	],
}